<template>
  <div>
    <section class="section">
      <div class="columns">
        <div class="column is-one-third is-offset-4">
          <h1 class="title has-text-centered">ข้อมูลห้องปฏิบัติการ</h1>
          <b-field>
            <b-input v-model="lab.name" placeholder="ชื่อห้องปฏิบัติการ/สถานพยาบาล"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.address" placeholder="ที่อยู่"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.district" placeholder="อำเภอ/เขต"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.province" placeholder="จังหวัด"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.tel" placeholder="โทรศํพท์"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.line" placeholder="Line"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.facebook" placeholder="Facebook หรือ website"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.officeHour" placeholder="วันและเวลาทำการ"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.serviceCharge" placeholder="อัตราค่าบริการ"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.contactPerson" placeholder="ผู้ให้ข้อมูล"></b-input>
          </b-field>
          <b-field>
            <b-input v-model="lab.contact" placeholder="เบอร์ติดต่อ"></b-input>
          </b-field>
          <b-field label="จะวางจำหน่ายชุดตรวจสำหรับการทดสอบด้วยตนเอง">
            <b-radio native-value="yes" v-model="lab.atk.distribution">มี</b-radio>
            <b-radio native-value="no" v-model="lab.atk.distribution">ไม่มี</b-radio>
          </b-field>
          <b-field>
            <b-input v-model="lab.atk.price" placeholder="ราคาที่คาดการณ์โดยประมาณ"></b-input>
          </b-field>
          <div class="buttons is-centered">
            <button class="button is-success" @click="save">Save</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {db} from '../firebase'

export default {
  name: "LabForm",
  data() {
    return {
      lab: {
        address: null,
        district: null,
        province: null,
        tel: null,
        line: null,
        facebook: null,
        officeHour: null,
        serviceCharge: null,
        contactPerson: null,
        contact: null,
        atk: {
          distribution: false,
          price: 0
        }
      },
    }
  },
  methods: {
    reset: function () {
      this.lab = {
        address: null,
        district: null,
        province: null,
        tel: null,
        line: null,
        facebook: null,
        officeHour: null,
        serviceCharge: null,
        contactPerson: null,
        contact: null,
        atk: {
          distribution: false,
          price: 0
        }
      }
    },
    save: function () {
      db.collection("labs").add(this.lab).then(() => {
        this.reset()
        this.$buefy.toast.open({
          message: "Saved it.",
          type: "is-success"
        })
      })
    }
  },
}
</script>

<style scoped>

</style>